var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("\n  Error: 404\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }